



























































































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { ActionMethod } from '@/Shared/CommonEntityMixins/Enums';
import { LotLkup, LotMaxDailyFee } from './LotLkup';
import { UrlOptions } from '@/Shared/CommonEntityMixins/UrlConfig';
import { LocationLookupType } from '@/Stores/LookupStore';

const lots = mixins(LocationBasedMixin, BuildEntityListComponent<LotLkup>()).extend({
    data() {
        return {
            i18nPrefix: 'admin.lotMaintenance.lots',
            LocationLookupType,
        };
    },
    components: {
        RadioToggle: () => import('@/Shared/RadioToggle.vue'),
    },
    computed: {
        entityUrls(): UrlOptions {
            const urls: UrlOptions = {
                get: {
                    url: `/${this.location}/lotmaintenance/GetLots`,
                    urlAction: ActionMethod.GET
                },
                update: {
                    url: `/${this.location}/lotmaintenance/UpsertLot`,
                    urlAction: ActionMethod.POST
                },
                delete: {
                    url: `/${this.location}/lotmaintenance/deletelotlkup`,
                    urlAction: ActionMethod.PUT
                }
            };

            return urls;
        }
    },
    methods: {
        add() {
            if (this.editItem && !this.editItem.recID) {
                return;
            }
            const newMap = {
                lotMaxDailyFee: {} as LotMaxDailyFee,
            } as LotLkup;
            this.entities.splice(0, 0, newMap);
            this.edit({} as LotLkup);
        },
        edit(mapping: LotLkup) {
            this.cancelEdit();
            this.editItem = Object.assign({}, mapping);
            if (!this.editItem.lotMaxDailyFee) {
                this.editItem.lotMaxDailyFee = {} as LotMaxDailyFee;
            }
        },
    }
});

export default lots;
